/** Formats a Date to the `YYYY-MM-DD` string expected by `<input type="date">`. */
export function formatDateValue(value: Date | null | undefined): string {
  if (!(value instanceof Date) || isNaN(value.getTime())) return '';
  return value.toISOString().slice(0, 10);
}

/** Parses a `YYYY-MM-DD` string into a Date at UTC midnight. */
export function parseDateInputValue(value: string): Date {
  return new Date(`${value}T00:00:00.000Z`);
}

/** Parses a `YYYY-MM-DD` string into a Date, or returns `undefined` for empty input. */
export function parseOptionalDateInputValue(value: string): Date | undefined {
  return value === '' ? undefined : new Date(`${value}T00:00:00.000Z`);
}
